import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchDeliverySettingEntity } from '../../domain/entities/BranchDeliverySettingEntity'
import type { BranchDeliverySystemAdminDto } from '@/backend/market'
import { BranchSegmentModel } from './BranchSegmentModel'

export class BranchDeliverySettingModel extends BranchDeliverySettingEntity {
  constructor(dataDto: BranchDeliverySystemAdminDto) {
    super()
    const branchSegments = dataDto.perDirectDistanceSegment?.segments?.map(
      (segment) => new BranchSegmentModel(segment)
    )
    mapEntityProperties<BranchDeliverySettingEntity>(this, dataDto, {
      map: {
        perDirectDistanceSegment: {
          segments: branchSegments
        }
      }
    })
  }
}
